import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getUserInfo, UserInfoResponse } from 'src/api/userService';

import { queryRetry } from '../query-retry';

export const useGetUserInfo = (userLoggedIn: boolean) => {
    const query = useQuery<UserInfoResponse, AxiosError>({
        enabled: userLoggedIn,
        queryKey: ['getUserInfo'],
        queryFn: () => getUserInfo(),
        retry: queryRetry,
    });

    return {
        ...query,
    };
};
